import React, { useState, useEffect } from "react";
import { Icon, Row, Col, Button, RSelect } from "../../../components/Component";
// import { getDateFormat } from "../../utils/Utils";
import { getDateFormat } from "../../../utils/Utils";
import DatePickerHeader from "./DatePickerHeader";
import DatePicker from "react-datepicker";
import { useSelector, useDispatch } from 'react-redux';
import SearchComponent from "./SearchComponent";
// import "../../../assets/css/style.css";

const TableHead = ({
    searchHandler,
    searchFieldData,
    seachFeildType,
    reloadHandler,
    setSearchText,
    setSelectedItems,
    checkResponse,
    setCurrentPage,
    pageName,
    showDatePicker = false,
    showSearchBar = true,
}) => {

    const dispatch = useDispatch();

    const [tablesm, updateTableSm] = useState(false);
    const [onSearch, setonSearch] = useState(showSearchBar);
    const [onRefreshPage, setOnRefreshPage] = useState(false);
    const key = Object.keys(searchFieldData);
    let updatedSearchFieldData = {};
    {
        key.map((field, i) => {
            updatedSearchFieldData[field] = "";
        });
    }

    const [state, setState] = useState(updatedSearchFieldData);
    const [rangeStart, setRangeStart] = useState();
    const [rangeEnd, setRangeEnd] = useState();
    const [isReset, setIsReset] = useState(false);


    useEffect(() => {
        setState({ ...searchFieldData });
        setRangeStart('');
        setRangeEnd('');
        setOnRefreshPage(true);
    }, [checkResponse])

    useEffect(() => {
        setState({
            ...state,
            ["startDate"]: "",
            ["endDate"]: "",
        });
    }, []);


    useEffect(() => {
        setState({
            ...state,
            ["startDate"]: rangeStart !== undefined ? getDateFormat(rangeStart) : "",
        });
    }, [rangeStart]);

    useEffect(() => {
        setState({
            ...state,
            ["endDate"]: rangeEnd !== undefined ? getDateFormat(rangeEnd) : "",
        });
    }, [rangeEnd]);

    const toggle = () => {
        setonSearch(!onSearch);
        const keys = Object.keys(searchFieldData);
        Object.keys(searchFieldData).forEach((i) => (searchFieldData[i] = ""));
    };

    const handleSearch = () => {
        if (state["startDate"] === "" || state["endDate"] === "") {
            setState({ ...state, ["startDate"]: "" });
            setState({ ...state, ["endDate"]: "" });
        }
        // const isEmpty = !Object.values(state).some((x) => x !== null && x !== "");
        // if (!isEmpty) {
        searchHandler(state);
        // }
    };

    const keys = Object.keys(searchFieldData);

    const onChangeHandler = (evt) => {
        const value = evt.target.value;
        setState({
            ...state,
            [evt.target.name]: value,
        });
    };


    const onChangeParentCategoryHandler = (selectedValue, name) => {

        console.log(selectedValue);

        if (pageName == "order-revenue-chart") {
            dispatch({ type: 'SEARCH_DROPDOWN_VALUE', payload: selectedValue?.value })
        }



        setState({
            ...state,
            [name]: selectedValue,
        });

        // setState({
        //   ...state,
        //   [name]: selectedValue?.value,
        // });
    }

    const OnRefreshHandler = () => {
        setState({ ...searchFieldData });
        setRangeStart('');
        setRangeEnd('');
        reloadHandler();
        // toggle();
        setOnRefreshPage(true);
        setSelectedItems([]);
        setCurrentPage(1);
    };

    useEffect(() => {
        setOnRefreshPage(false);
        setState({ ...searchFieldData });
    }, [onRefreshPage]);

    const onEnterHandler = (e) => {
        if (e.key === "Enter") {
            searchHandler(state);
        }
    };


    const styles = {
        menu: (css) => ({
            ...css,
            width: "auto",
        }),
        control: (provided, state) => ({
            ...provided,
            background: '#fff',
            borderColor: '#9e9e9e',
            minHeight: '30px',
            height: '30px',
            boxShadow: state.isFocused ? null : null,
        }),

        valueContainer: (provided, state) => ({
            ...provided,
            height: '30px',
            padding: '0 6px'
        }),

        input: (provided, state) => ({
            ...provided,
            margin: '0px',
        }),
        indicatorSeparator: state => ({
            display: 'none',
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '30px',
        }),
    };

    return (
        <div className="card card-inner position-relative card-tools-toggle" style={{ boxShadow: 'none', marginBottom: '1px' }}>
            <div className="card-title-group">
                <div className="card-tools"></div>
                <div className="card-tools mr-n1">
                    <ul className="btn-toolbar gx-1">
                        <li>
                            <a
                                href="#search"
                                onClick={(ev) => {
                                    ev.preventDefault();
                                    toggle();
                                }}
                                className="btn btn-icon search-toggle toggle-search"
                            >
                                {/* <Icon name="search"></Icon> */}

                                <Button
                                    // style={{ background: "#BA3605", color: 'white', marginRight: "45px" }}
                                    className="search-submit btn-icon btn-primary"
                                >
                                    <Icon name="search"></Icon>
                                </Button>
                            </a>

                        </li>
                        <li className="btn-toolbar-sep"></li>
                        <li>
                            <div className="toggle-wrap">
                                <Button
                                    className={`btn-icon btn-trigger toggle ${tablesm ? "active" : ""}`}
                                    onClick={() => {
                                        updateTableSm(true);
                                    }}
                                >
                                    <Icon name="menu-right"></Icon>
                                </Button>
                                <div className={`toggle-content ${tablesm ? "content-active" : ""}`}>
                                    <ul className="btn-toolbar gx-1">
                                        <li className="toggle-close">
                                            <Button
                                                className="btn-icon btn-trigger toggle"
                                                onClick={() => {
                                                    updateTableSm(false);
                                                }}
                                            >
                                                <Icon name="arrow-left"></Icon>                                                
                                            </Button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div className={`card-search search-wrap ${!onSearch && "active"}`}>

                <Col md="1">
                    <Button
                        className="search-back btn-icon toggle-search active"
                        onClick={() => {
                        setSearchText("");
                        toggle();
                        // reloadHandler();
                        OnRefreshHandler();
                        }}
                    >
                        <Icon name="arrow-left"></Icon>
                    </Button>
                </Col>

                <SearchComponent
                    searchHandler={searchHandler}
                    searchFieldData={searchFieldData}
                    seachFeildType={seachFeildType}
                    reloadHandler={reloadHandler}
                    setSearchText={setSearchText}
                    setSelectedItems={setSelectedItems}
                    checkResponse={checkResponse}
                    setCurrentPage={setCurrentPage}
                    pageName={pageName}
                    showDatePicker={showDatePicker}
                    showSearchBar={showSearchBar}
                    toggle={toggle}
                    toggleSearchModal={() => {}}
                />

            </div>
        </div>
    );
};

export default TableHead;